import { Button } from "antd";
import React from "react";

interface EditButtonProps {
  handleClick: () => void;
}

export default (props: EditButtonProps): JSX.Element => {
  return (
    <Button
      style={{
        fontWeight: "normal",
      }}
      className="base-button"
      onClick={props.handleClick}
    >
      Edit
    </Button>
  );
};
